'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('../../transport/transport.js');

class Loyalty {
  userProgress(params) {
    return transport.transport.request("loyalty/userProgress", params);
  }
  history() {
    return transport.transport.request("loyalty/history");
  }
  rank(params) {
    return transport.transport.request("loyalty/rank", params);
  }
}

exports.Loyalty = Loyalty;
